import * as XLSX from 'xlsx';
import type { ImportRow } from '../types/import';

export interface ParseResult {
  data: ImportRow[];
  errors: string[];
}

export const parseExcelFile = (file: File): Promise<ParseResult> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Tomar la primera hoja
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        // Convertir a JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        if (jsonData.length < 2) {
          resolve({
            data: [],
            errors: ['El archivo debe tener al menos una fila de encabezados y una fila de datos']
          });
          return;
        }
        
        const headers = jsonData[0] as string[];
        const rows = jsonData.slice(1) as string[][];
        
        // Validar encabezados requeridos
        const requiredHeaders = ['nombres', 'apellidos', 'email', 'telefono', 'nombre del evento', 'programa de interes'];
        const missingHeaders = requiredHeaders.filter(
          header => !headers.some(h => h.toLowerCase().includes(header.toLowerCase()))
        );
        
        if (missingHeaders.length > 0) {
          resolve({
            data: [],
            errors: [`Faltan las siguientes columnas requeridas: ${missingHeaders.join(', ')}`]
          });
          return;
        }
        
        // Mapear columnas
        const headerMap = {
          nombres: headers.findIndex(h => h.toLowerCase().includes('nombres')),
          apellidos: headers.findIndex(h => h.toLowerCase().includes('apellidos')),
          email: headers.findIndex(h => h.toLowerCase().includes('email')),
          telefono: headers.findIndex(h => h.toLowerCase().includes('telefono')),
          nombreEvento: headers.findIndex(h => h.toLowerCase().includes('nombre del evento')),
          programaInteres: headers.findIndex(h => h.toLowerCase().includes('programa de interes'))
        };
        
        const parsedData: ImportRow[] = [];
        const errors: string[] = [];
        
        rows.forEach((row, index) => {
          const rowNumber = index + 2; // +2 porque empezamos desde la fila 2 (después del header)
          const rowErrors: string[] = [];
          
          // Validar que la fila no esté vacía
          if (row.every(cell => !cell || cell.toString().trim() === '')) {
            return; // Saltar filas vacías
          }
          
          const nombres = row[headerMap.nombres]?.toString().trim() || '';
          const apellidos = row[headerMap.apellidos]?.toString().trim() || '';
          const email = row[headerMap.email]?.toString().trim() || '';
          const telefono = row[headerMap.telefono]?.toString().trim() || '';
          const nombreEvento = row[headerMap.nombreEvento]?.toString().trim() || '';
          const programaInteres = row[headerMap.programaInteres]?.toString().trim() || '';
          
          // Validaciones
          if (!nombres) {
            rowErrors.push('Nombres es requerido');
          }
          
          if (!apellidos) {
            rowErrors.push('Apellidos es requerido');
          }
          
          
          if (!telefono) {
            rowErrors.push('Teléfono es requerido');
          }
          
          if (!nombreEvento) {
            rowErrors.push('Nombre del evento es requerido');
          }
          
          
          if (rowErrors.length > 0) {
            errors.push(`Fila ${rowNumber}: ${rowErrors.join(', ')}`);
          }
          
          parsedData.push({
            id: `row-${index}`,
            nombres,
            apellidos,
            email,
            telefono,
            nombreEvento,
            programaInteres,
            errors: rowErrors
          });
        });
        
        resolve({
          data: parsedData,
          errors
        });
        
      } catch (error) {
        reject(new Error('Error al procesar el archivo Excel'));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Error al leer el archivo'));
    };
    
    reader.readAsArrayBuffer(file);
  });
};

// const isValidEmail = (email: string): boolean => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return emailRegex.test(email);
// };

export const downloadTemplate = () => {
  const templateData = [
    ['nombres', 'apellidos', 'email', 'telefono', 'nombre del evento', 'programa de interes'],
    ['Juan', 'Pérez', 'juan.perez@email.com', '1234567890', 'Conferencia IA 2024', 'Inteligencia Artificial'],
    ['María', 'García', 'maria.garcia@email.com', '0987654321', 'Workshop Marketing', 'Marketing Digital']
  ];
  
  const worksheet = XLSX.utils.aoa_to_sheet(templateData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla');
  
  XLSX.writeFile(workbook, 'plantilla_importacion_leads.xlsx');
};
